import DefaultValidation from '@/services/validations/DefaultValidation';
import * as Util from '@/functions/Util';

export default class ContatoValidation extends DefaultValidation {
    validate(model, refs) {
        let validated = true;

        if (Util.isNull(model.nome)) {
            refs.nomeInput.focusedOut = true;
            validated = false;
        }
        if (!Util.isNull(model.cpf) && !Util.validateCPF(model.cpf)) {
            refs.cpfInput.focusedOut = true;
            validated = false;
        }
        if (!Util.isNull(model.email) && !Util.validateEmail(model.email)) {
            refs.emailInput.focusedOut = true;
            validated = false;
        }
        // if (!Util.isNull(model.telefone) && !Util.validatePhone(model.telefone)) {
        // 	refs.telefoneInput.focusedOut = true;
        // 	validated = false;
        // }

        return validated;
    }
}
